import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import News from "./components/CentralSide/News/News"
import UserCabinet from "./components/CentralSide/UserCabinet/UserCabinet"
import FilesList from "./components/CentralSide/FilesList/FilesList"
import Stages from "./components/CentralSide/Stages/Stages"
import modifyStages from "./components/CentralSide/modifyStages/modifyStages"
import edu from "./components/CentralSide/edu/edu";
import anketa from "./components/anketa/anketa";
import cultureAnketaExpert from "./components/anketa/culture/expert";
import cultureAnketMun from "./components/anketa/culture/mun";
import eduAnkExp from "./components/anketa/edu/expert";
import eduAnkMun from "./components/anketa/edu/mun";
import NewsAdmin from "./components/CentralSide/NewsAdmin/NewsAdmin"
import foto from "./components/CentralSide/foto/foto"
import Fotocheck from "./components/CentralSide/Fotocheck/Fotocheck"
import FotocheckCulture from "./components/CentralSide/Fotocheck/FotocheckCulture"
import SchoolExpertFoto from "./components/CentralSide/schoolExpertFoto/schoolExpertFoto"
import userjson from "./assets/user.json";

import axios from "axios";

Vue.config.productionTip = false
Vue.use(VueRouter);

const routes = [
  {
    path: '/schoolexpertfoto/:id',
    component: SchoolExpertFoto
  },
  {
    path: '/newsadmin',
    component: NewsAdmin
  },
  {
    path: '*',
    component: News
    //component: anketa
  },
  {
    path: '/fotocheck',
    component: Fotocheck
  },
  {
    path: '/fotocheckc',
    component: FotocheckCulture
  },
  {
    path: '/cabinet',
    component: UserCabinet
  },
  {
    path: '/eae/:id',
    component: eduAnkExp
  },
  
  {
    path: '/cam/:id',
    component: cultureAnketMun
  },
  {
    path: '/cae/:id',
    component: cultureAnketaExpert
  },
  {
    path: '/eam/:id',
    component: eduAnkMun
  },
  {
    path: '/anketa',
    component: anketa
  },
  {
    path: '/files/:type',
    component: FilesList,
    props: true
  },
  {
    path: '/stages',
    component: Stages
  },
  {
    path: '/modstages',
    component: modifyStages
  },
  {
    path: '/edu',
    component: edu
  },
  {
    path: '/foto/:id',
    component: foto
  }
  
]

const router = new VueRouter({
  mode: 'history',
  routes 
})


new Vue({
  methods:{
    getUser: function(){
      axios(
        {
          url: 'http://eduqa.egechita.ru/back/user',
          withCredentials: true,
        }).then((response) => {
        this.user = response.data;
      });
    }
  },
  created: function(){
    this.getUser();
  },
  data: () => {
    return {
      user: {}
    }
  },
  router,
  render: h => h(App),
}).$mount('#app')
